import React from 'react';
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer as MuiTableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { Pagination } from '../../../../Components/Pagination/Pagination';
import './LeaderboardTable.scss';

interface Column {
  id: string;
  label: string;
  width?: string;
  render?: (row: any) => React.ReactNode;
}

interface LeaderboardTableProps {
  columns: Column[];
  data: any[];
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  emptyMessage?: string;
  getRowClassName?: (row: any) => string;
}

export const LeaderboardTable: React.FC<LeaderboardTableProps> = ({
  columns,
  data,
  totalPages,
  currentPage,
  onPageChange,
  emptyMessage = 'No data found',
  getRowClassName,
}) => {
  if (data.length === 0) {
    return <div className="no-data-message">{emptyMessage}</div>;
  }

  return (
    <div className="leaderboard-table-container">
      <MuiTableContainer className="leaderboard-table">
        <MuiTable>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id} style={{ width: column.width }}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => (
              <TableRow key={row.id} className={getRowClassName ? getRowClassName(row) : undefined}>
                {columns.map((column) => {
                  const isTooltipColumn = ['office', 'area', 'agency'].includes(column.id);
                  const defaultContent = row[column.id];
                  const content = column.render ? column.render(row) : defaultContent;
                  return (
                    <TableCell key={column.id} style={{ width: column.width }}>
                      {column.render ? (
                        content
                      ) : (
                        <span
                          className="cell-text"
                          title={
                            isTooltipColumn && defaultContent ? String(defaultContent) : undefined
                          }
                        >
                          {content}
                        </span>
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </MuiTable>
      </MuiTableContainer>
      {totalPages > 1 && (
        <Pagination totalPages={totalPages} currentPage={currentPage} onPageChange={onPageChange} />
      )}
    </div>
  );
};
